import { motion } from "framer-motion";
import { Lock, PackageCheck, Sprout, Truck, Headphones } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const ICONS = { Lock, PackageCheck, Sprout, Truck, Headphones };
const ITEMS = [
  { icon: "Lock", label: "Secure Checkout", desc: "Encrypted, safe payments" },
  { icon: "PackageCheck", label: "Freshly Packed", desc: "Sealed for maximum crunch" },
  { icon: "Sprout", label: "Quality Ingredients", desc: "Real soya & spices" },
  { icon: "Truck", label: "Fast Delivery", desc: "Quick doorstep shipping" },
  { icon: "Headphones", label: "Easy Support", desc: "We're here to help" },
];

export default function TrustSection() {
  return (
    <section className="bg-black py-20 lg:py-24" data-testid="trust-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <div className="text-center">
            <Overline>You're In Good Hands</Overline>
            <h2 className="mt-3 font-display text-4xl tracking-tight text-cream sm:text-6xl">
              WHY SHOP <span className="text-gold-gradient">WITH US?</span>
            </h2>
          </div>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-5">
          {ITEMS.map((it, i) => {
            const Icon = ICONS[it.icon];
            return (
              <motion.div key={it.label}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                className="flex flex-col items-center rounded-2xl border border-white/10 bg-white/[0.03] p-6 text-center"
                data-testid={`trust-item-${i}`}>
                <Icon className="text-gold" size={28} />
                <h3 className="mt-4 font-oswald text-sm uppercase tracking-wide text-cream">{it.label}</h3>
                <p className="mt-1 text-[11px] text-white/40">{it.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
